import * as React from 'react';
import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import Toolbar from '@mui/material/Toolbar';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import Menu from '@mui/material/Menu';
import MenuIcon from '@mui/icons-material/Menu';
import Container from '@mui/material/Container';
import Avatar from '@mui/material/Avatar';
import Button from '@mui/material/Button';
import Tooltip from '@mui/material/Tooltip';
import MenuItem from '@mui/material/MenuItem';
import { Link, useHistory } from 'react-router-dom';
import Tasks from './AdminItems/Tasks';
import { makeStyles } from "@mui/styles";
import NotificationsIcon from '@mui/icons-material/Notifications';
import Badge from "@mui/material/Badge";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import moment from "moment";
import { height, width } from '@mui/system';
import {logger,permissions} from './utils';
const pages = ['Home', 'Summary','Tasks', 'Users','Site','Reports','ImportData','EventList'];
const settings = ['Profile', 'Account', 'Dashboard', 'Logout'];

 const pageStyles = makeStyles(theme => ({
    root: {
        "& .MuiPaper-root": {
            overflowy: "hidden"
        },
         "& .MuiPopover-paper": {
            minWidth: "140px",           
        },
        "& .MuiSvgIcon-root": {
            color: '#1f1b1e',
            colorPrimary: '#1f1b1e',
            fill: '#1f1b1e',
        },
        "& .MuiContainer-root": {
            "max-width": "100%"
        },
	 },
	 logo: {
		 width: 'auto',
		 height: 'auto',
		 maxWidth: '100%',
		 maxHeight: '100%',
	 },
	 marquee: {
		 whiteSpace: 'nowrap',
		 overflow: 'hidden',
		 position: 'relative',
		 maxWidth: '100%', // Adjust maximum width as needed
		 paddingTop: 25, // Adjust padding top as needed
		 //paddingLeft: 200, // Adjust padding left as needed
		 paddingRight: 100, // Adjust padding right as needed	
		 marginRight:50,
		 //color: '#fc0349',
		 '&::before, &::after': {
			 content: '""',
			 position: 'absolute',
			 top: 0,
			 width: '50%',
			 height: '100%',
			 //boxShadow: `inset 0 0 10px ${theme.palette.background.paper}`, // Optional: Add a shadow effect
		 },
		 '&::before': {
			 left: 0,
		 },
		 '&::after': {
			 right: 0,
		 },
	 },
	 scrollingText: {
		 display: 'inline-block',
		 animation: '$marquee 10s linear infinite', // Adjust duration and timing function as needed
	 },
	 '@keyframes marquee': {
		 '0%': {
			 transform: 'translateX(100%)',
		 },
		 '100%': {
			 transform: 'translateX(-100%)',
		 },
	 },
}));  

const Navbar = () => {
    const [anchorElNav, setAnchorElNav] = React.useState<null | HTMLElement>(null);
    const [anchorElUser, setAnchorElUser] = React.useState<null | HTMLElement>(null);
    const [isLoggedIn, setLoggedIn] = React.useState(false);
    const [userName, setUserName] = React.useState(null);
    const {showCalendar} = false;
    const [component, setComponent] = React.useState('home');
    const [LockedAlert, setAlert] = React.useState(false);
    const [alertText, setAlertText] = React.useState([]);
    const [badgeNumber, setBadgeNumber] = React.useState(0);
    const [refresh, setRefresh] = React.useState(true);
    const [urgentText, setUrgentText] = React.useState('');
  	const [permissions, setPermissions] = React.useState({});
    const classes = pageStyles();

    const handleOpenNavMenu = (event: React.MouseEvent<HTMLElement>) => {
        setAnchorElNav(event.currentTarget);
    };
    const handleOpenUserMenu = (event: React.MouseEvent<HTMLElement>) => {
        setAnchorElUser(event.currentTarget);
    };

	const handleAlertOpen = () => {
        setAlert(true);
    };
	const handleAlertClose = () => {
        setAlert(false);
    };
    React.useEffect(() => {
        fetch('/api/checkAuth')
            .then(res => {
                if (res.status === 200) {
                    setLoggedIn(true);
                } else {
                    setLoggedIn(false);
                }
            })
            .catch(err => {
                console.error(err)
                setLoggedIn(false);
            });
            
         if(refresh && isLoggedIn){
	        fetch('/api/get_active_events')
	            .then(res => res.json())
	            .then(json => setEvents(json))
	            .catch(err => {
                console.error(err);
            });
            
            fetch('/api/User/Permission')
                .then(res => res.json())
                .then(json => setPermissions(json))
                .then(json => logger(json))

            setRefresh(false);
		 }
    });

    const handleLogout = () => {
        fetch('/api/Logout')
            .then(res => {
                if (res.ok) {
                    alert("Logged out succesfully");
                    window.location.reload();
                }
            })

    };
    
    Date.prototype.getWeekNumber = function(){
	  var d = new Date(+this);
	  d.setHours(0,0,0);//from w w w.  j a  va2s.  c  o m
	  d.setDate(d.getDate()+4-(d.getDay()||7));
	  return Math.ceil((((d-new Date(d.getFullYear(),0,1))/8.64e7)+1)/7);
	};
    
	/*const getWeekNumber = () => {
		var currentDate = new Date();
		var startDate = new Date(currentDate.getFullYear(), 0, 1);
		var days = Math.floor((moment.utc(currentDate) - moment.utc(startDate)) / (24 * 60 * 60 * 1000));

		let weekNumber = Math.ceil(days / 7);
		return weekNumber;
	}*/
    
    /*const setEvents = (json) => {
        var temp = [];
        json.forEach(choice => temp.push(choice.EventText));
        setAlertText(temp);
        setBadgeNumber(temp.length);
    };
    */
  
const setEvents = (json) => {
	const weekdays = ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday", "Sunday"];
	/*const [typeChoices, setTypeChoices] = React.useState([
		{ label: 'None', value: 0 },
		{ label: 'Daily', value: 1 },
		{ label: 'Weekly', value: 2 },
		{ label: 'Bi-Weekly', value: 3 },
		{ label: 'Monthly', value: 4}
	])
	
	const [weekdays, setWeekdays] = React.useState([
		{ label: 'Monday', value: 0 },
		{ label: 'Tuesday', value: 1 },
		{ label: 'Wednesday', value: 2 },
		{ label: 'Thursday', value: 3 },
		{ label: 'Friday', value: 4 },
		{ label: 'Saturday', value: 5 },
		{ label: 'Sunday', value: 6 }
	]);
	
	const [biweekly, setBiweekly] = React.useState([
		{ label: 'Odd', value: 0 },
		{ label: 'Even', value: 1 }
	])*/
	var urgentsText = "";
	const events = json.filter(choice => {
		var temp = choice.RecurringStart.split("#");
		var recurringStart =  choice.RecurringStart;
		var recurringPeriod = choice.RecurringPeriod;
		var currentWeekDayNumber = new Date().getDay();
		let currentWeekNumber = new Date().getWeekNumber();
		let currentDayDate = moment.utc(new Date()).date();

		logger("EventText", choice.EventText);
		logger("recurringStart", recurringStart, typeof(recurringStart));
		logger("recurringPeriod", recurringPeriod, typeof(recurringPeriod));
		logger("currentWeekDayNumber", currentWeekDayNumber, typeof(currentWeekDayNumber));
		logger("currentWeekNumber", currentWeekNumber, typeof(currentWeekNumber));
		logger("currentDayDate", currentDayDate, typeof(currentDayDate));
		logger("******************************************************************");
		
		//Urgent
		if (choice.Urgent === 1) {
			logger("Urgent", choice.EventText );
			urgentsText = urgentsText!=="" ? urgentsText + " \xa0 \xa0 \xa0 \xa0 \xa0 \xa0 \xa0"+ choice.EventText : choice.EventText;
		}
		
		
		//Daily
		if (choice.Recurring === 0) {
			logger("First");
			return true;
		}
		//Weekly
		if (choice.Recurring === 1) {
			logger("Second");
			if (currentWeekDayNumber >= (parseInt(recurringStart) + 1) && currentWeekDayNumber <= (parseInt(recurringStart) + 1 + recurringPeriod - 1)) {
				logger("Third");
				return true;
			}
		}

		//Bi-Weekly Odd
		if (choice.Recurring === 2) {
			logger("Fourth");
			if (currentWeekNumber % 2 !== 0 && currentWeekDayNumber >= (parseInt(recurringStart) + 1)
				&& currentWeekDayNumber <= (parseInt(recurringStart) + 1 + recurringPeriod - 1)) {
				logger("Fifth");
				return true;
			}
		}

		//Bi-Weekly Even
		if (choice.Recurring === 3) {
			logger("Sixth");
			if (currentWeekNumber % 2 === 0 && currentWeekDayNumber >= (parseInt(recurringStart) + 1)
				&& currentWeekDayNumber <= (parseInt(recurringStart) + 1 + recurringPeriod - 1)) {
				logger("Eigth");
				return true;
			}
		}
		
		if (choice.Recurring === 4) {
			    logger("Seventh");
			    let selectedDateInCalendar = new Date(recurringStart).getDate() + 1;
			    let endDateInCalendar = selectedDateInCalendar + recurringPeriod - 1;
			    logger("selectedDateInCalendar", selectedDateInCalendar);
			    logger("endDateInCalendar", endDateInCalendar);
			    if (currentDayDate >= selectedDateInCalendar && currentDayDate <= endDateInCalendar) {
			        logger("Monthly Event is today or within the period");
			        return true;
			    }
			}

	}).map(content=>{
		const color = content.color || 'black';
		const style = { color: color };
		
		return <span style={style}>{content.EventText}</span>;
	});

	
	setUrgentText(urgentsText);
    setAlertText(events);
    setBadgeNumber(events.length);
}


   
    const getBadgeProps = () => {
		if(badgeNumber>0){
			return(
	        <Badge title="Notifications" badgeContent={badgeNumber} overlap="circular" color="error" sx={{ p: 0, width: 40, height: 40 }} onClick={handleAlertOpen}>
		        <NotificationsIcon sx={{ p: 0, width: 40, height: 40 }}/>
		    </Badge>
		    );
    	}else{
			return(
	        <Badge title="Notifications" overlap="circular" color="error" sx={{ p: 0, width: 40, height: 40 }} onClick={handleAlertOpen}>
		        <NotificationsIcon sx={{ p: 0, width: 40, height: 40 }}/>
		    </Badge>
		    );
		}
    };

    const handleCloseNavMenu = () => {
        setAnchorElNav(null);
    };

    const handleCloseUserMenu = () => {
        setAnchorElUser(null);
    };

    return (
        <AppBar className={classes.root} position="fixed" sx={{height: "65px", overflow: "hidden", alignItems: "center", justifyContent: "center", zIndex: "1201"}}>
            <Container sx={{ marginLeft: 0, marginRight: 0 }}>
                <Toolbar sx={{ display: 'flex', justifyContent:'space-between' }}>
                    <Box sx={{ display: 'flex'}} >
                        <IconButton
                            size="large"
                            aria-label="account of current user"
                            aria-controls="menu-appbar"
                            aria-haspopup="true"
                            onClick={handleOpenNavMenu}
                            color="inherit"
                        >
                            <MenuIcon fontSize="large"/>
                        </IconButton>
                        <Menu
                            className={classes.root}
                            id="menu-appbar"
                            anchorEl={anchorElNav}
                            anchorOrigin={{
                                vertical: 'bottom',
                                horizontal: 'left',
                            }}
                            keepMounted
                            transformOrigin={{
                                vertical: 'top',
                                horizontal: 'left',
                            }}
                            open={Boolean(anchorElNav)}
                            onClose={handleCloseNavMenu}
                            sx={{ display: 'block' }}
                        >                            
                            <MenuItem component={Link} key="Home" onClick={handleCloseNavMenu} to='/Home'>
                                <Typography textAlign="center" variant="h6" style={{ color: "black" }}>Home</Typography>
                            </MenuItem>
                            <MenuItem component={Link} key="Summary" onClick={handleCloseNavMenu} to='/Summary'>
                                <Typography textAlign="center" variant="h6" style={{ color: "black" }}>Summary</Typography>
                            </MenuItem>
                            {permissions.CreateTasks === 1 && (
                            <MenuItem component={Link} key="Tasks" onClick={handleCloseNavMenu} to='/Tasks'>
                                <Typography textAlign="center" variant="h6" style={{ color: "black" }}>Tasks</Typography>
                            </MenuItem>)}
                            {permissions.ViewUser==1 && (
                            <MenuItem component={Link} key="Users" onClick={handleCloseNavMenu} to='/Users'>
                                <Typography textAlign="center" variant="h6" style={{ color: "black" }}>Users</Typography>
                            </MenuItem>)}
                            {permissions.ViewSOW==1 && (
                            <MenuItem component={Link} key="Site" onClick={handleCloseNavMenu} to='/Site'>
                                <Typography textAlign="center" variant="h6" style={{ color: "black" }}>Site</Typography>
                            </MenuItem>)}
                            {permissions.CreateUser==1 &&(
                            <MenuItem component={Link} key="Reports" onClick={handleCloseNavMenu} to='/Reports'>
                                <Typography textAlign="center" variant="h6" style={{ color: "black" }}>Reports</Typography>
                            </MenuItem>)}
                            {permissions.CreateUser == 1 && (
                            <MenuItem component={Link} key="ImportData" onClick={handleCloseNavMenu} to='/Import'>
                                <Typography textAlign="center" variant="h6" style={{ color: "black" }}>Import Data</Typography>
                            </MenuItem>)}
                             {permissions.CreateEvent == 1 && (
                            <MenuItem component={Link} key="EventList" onClick={handleCloseNavMenu} to='/Events'>
                                <Typography textAlign="center" variant="h6" style={{ color: "black" }}>Events</Typography>
                            </MenuItem>)}
                        </Menu>
                        <Typography
                            variant="h6"
                            noWrap
                            component="div"
                            sx={{ display: { xs: 'none', md: 'flex' },
                            '& img': {
                                height: '77px',
                                marginLeft: '10px'
                            } }}
                        >
                            <img src={require('./img/Beyondsoft English logo_white.png')} alt="BCILogo" />
                        </Typography>
                        <Typography
                            variant="h6"
                            noWrap
                            component="div"
                            sx={{ display: { xs: 'flex', md: 'none' },
                            '& img': { // Style applied to the img element
                                    width: '50px', 
                                    height: '50px',
                                    padding: '5px'
                                },
                                }}
                        >
                            <img src={require('./img/Beyondsoft English logo_white_Icon_only.png')} alt="BCILogo" />
                        </Typography>
                    </Box>
					<Box sx={{ display: 'flex' }}>
						{/*<Box sx={{ flexGrow: 1, display: { xs: 'none', md: 'flex' } }}>
							<Button
								className="navBarButton"
								component={Link}
								key='Home'
								onClick={handleCloseNavMenu}
								sx={{ my: 2, color: 'white', display: 'block' }}
								to='/Home'
							>
								<Typography textAlign="center" variant="h6" style={{ color: "white" }}>Home</Typography>
							</Button>
						</Box>*/}
						<Box sx={{ display: 'flex' }}>
							{urgentText !== '' && <div className={classes.marquee} >
								<Typography variant="h6" className={classes.scrollingText} >
									{urgentText}
								</Typography>
							</div>
							}
						</Box>

						{showCalendar && <Button
							className="navBarButton"
							component={Link}
							key='Calendar'
							onClick={handleCloseNavMenu}
							sx={{ color: 'white', display: 'block' }}
							to='/Calendar'
						>
							<Typography textAlign="center" variant="h6" style={{ color: "white" }}>Calendar</Typography>
						</Button>}
					</Box>
                    {isLoggedIn ?(
                    <Box>
                        {getBadgeProps()}
                        <Tooltip title="Open settings">
                            <IconButton onClick={handleOpenUserMenu} sx={{ marginLeft: "10px" }}>
                                    <Avatar alt={userName} />
                            </IconButton>
                        </Tooltip>
                        <Menu
                                sx={{
                                    overflowy: 'auto',
                                    overflowx: 'hidden',
                                    minwidth: '16px',
                                    minheight: '16px',
                                    maxwidth: 'calc(100% - 32px)',
                                    maxheight: 'calc(100% - 32px)',
                                }}

                                style={{
                                    overflowY: 'auto',
                                    overflowX: 'hidden',
                                    minWidth: '16px',
                                    minHeight: '16px',
                                    maxWidth: 'calc(100% - 32px)',
                                    maxHeight: 'calc(100% - 32px)'
                                }}
                            id="menu-appbar"
                            anchorEl={anchorElUser}
                            anchorOrigin={{
                                vertical: 'top',
                                horizontal: 'right',
                            }}
                            keepMounted
                            transformOrigin={{
                                vertical: 'top',
                                horizontal: 'right',
                            }}
                            open={Boolean(anchorElUser)}
                            onClose={handleCloseUserMenu}
                        >
                                <MenuItem component={Link} key="Profile" onClick={handleCloseUserMenu} to='/Profile'>
                                    <Typography textAlign="center" variant="h6" style={{ color: "black" }}>Profile</Typography>
                            </MenuItem>
                                <MenuItem component={Link} key="Admin" onClick={handleCloseUserMenu} to='/Admin'>
                                    <Typography textAlign="center" variant="h6" style={{ color: "black" }}>Admin Panel</Typography>
                            </MenuItem>
                            <MenuItem component={Link} key="Logout" onClick={handleLogout} to='/'>
                                    <Typography textAlign="center" variant="h6" style={{ color: "black" }}>Logout</Typography>
                            </MenuItem> 
                        </Menu>
                        <Dialog
			                open={badgeNumber>0 && LockedAlert}
			                onClose={handleAlertClose}
			                aria-labelledby="Notifications"
			                aria-describedby="All active notifications"
			            >
			                <DialogTitle id="notifications" textAlign="center" variant="h6" style={{ color: "blue" }}>
			                    {"Notifications"}
			                </DialogTitle>
			                <DialogContent>
			                    <DialogContentText id="alert-dialog-description">
		                            {alertText.map((a, index) => {
										return(<p key={index}>{a}</p>)
										})}
					            </DialogContentText>
			                </DialogContent>
			                <DialogActions>
			                    <Button onClick={() => { setAlert(false) }} autoFocus>Close</Button>
			                </DialogActions>
			            </Dialog>
                    </Box>)
                        : (<Button color="inherit" component={Link}
                            key='Login'
                            to='/Login'><Typography textAlign="center" variant="h6" style={{ color: "white" }}>Login</Typography></Button>)}
                </Toolbar>
            </Container>
        </AppBar>
    );
};
export default Navbar;